module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('div', {
    staticClass: "Joinbanner"
  }, [_c('div', {
    staticClass: "MethodsBanner"
  }, [_c('img', {
    staticClass: "MethodsPic",
    attrs: {
      "src": require("../assets/product.png")
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Job",
    staticStyle: {
      "top": "0"
    }
  }, [_c('div', {
    staticClass: "payy"
  }, [_c('img', {
    staticClass: "payPic",
    attrs: {
      "src": require("../assets/pay.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "payContent"
  }, [_c('span', [_vm._v("聚合支付")]), _vm._v(" "), _c('p', [_vm._v("微信支付、支付宝支付、QQ钱包刷卡支付等全面支持")])])]), _vm._v(" "), _c('div', {
    staticClass: "selll"
  }, [_c('img', {
    staticClass: "sellPic",
    attrs: {
      "src": require("../assets/sell.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sellContent"
  }, [_c('span', [_vm._v("自动营销")]), _vm._v(" "), _c('p', [_vm._v("七种武器:"), _c('br'), _c('br'), _vm._v("1.吸星大法。凡关注游艺厅公众号皆可设置赠送游戏币，吸粉速度超级快"), _c('br'), _c('br'), _vm._v(" 2.移花接木。玩家转发推荐朋友关注公众号，可以获得游戏币奖励或者积分奖励\n\n          "), _vm._v(" "), _c('br'), _c('br'), _vm._v(" 3.金色梧桐。独特摇一摇功能，可以摇到游戏币、卡劵、积分等，提升玩家到店率，联合周边商家一起做导流\n\n          "), _c('br'), _c('br'), _vm._v(" 4.不动如山。每日签到功能，玩家每天在公众号论坛签到，可以累积积分，或者额外惊喜，领取大量游戏币\n\n          "), _c('br'), _c('br'), _vm._v(" 5.千环套月。套餐设置，支持游戏币、商城商品的套餐，优惠设置，牢牢锁住客户\n\n          "), _c('br'), _c('br'), _vm._v(" 6.万法归宗。独有的竞技比赛模块，让玩家在玩游戏的时候，体验竞技的刺激，真人对抗，晋级飞升天降大奖，让玩家欲罢不能\n\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "shopp"
  }, [_c('img', {
    staticClass: "shopPic",
    attrs: {
      "src": require("../assets/shop.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "shopContent"
  }, [_c('span', [_vm._v("积分商城")]), _vm._v(" "), _c('p', [_vm._v("酷酷宝系统为每个游艺厅建立各自的积分商城系统"), _c('br'), _c('br'), _vm._v("1.自由发布商品、编辑和美化，包括游戏币、玩具 日常用品等实物实物和虚拟商品\n\n          "), _c('br'), _c('br'), _vm._v("2.商城定价系统。完美匹配游艺厅经营，可以采用多种支付方式，包括积分兑换、酷币兑换、现金支付 以上各种组合支付\n\n          "), _c('br'), _c('br'), _vm._v("3.提供专有虚拟商品。为游艺厅提供好酷专有的电话卡、流量卡、游戏点卡等虚拟商品，协助游艺厅丰富礼品库，提高积分价值")])])]), _vm._v(" "), _c('div', {
    staticClass: "union"
  }, [_c('img', {
    staticClass: "unionPic",
    attrs: {
      "src": require("../assets/union.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unionContent"
  }, [_c('span', [_vm._v("跨界联盟")]), _vm._v(" "), _c('p', [_vm._v("酷酷宝系统为游艺厅做异业联盟研发了便捷的积分支付、对账结算系统"), _c('br'), _c('br'), _vm._v(" 玩家只需使用微信扫一扫游艺厅为联盟商家提供的二维码，即可实现积分支付，全自动积分匹配消费金额，积分支付不限额度。"), _c('br'), _c('br'), _vm._v(" 联盟商家管理员可以自助通过手机端，实时查询交易记录。\n\n          "), _c('br'), _c('br')])])]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('img', {
    staticClass: "centerPic",
    attrs: {
      "src": require("../assets/center.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "centerContent"
  }, [_c('span', [_vm._v("游戏中心")]), _vm._v(" "), _c('p', [_vm._v("1.为游艺厅提供海量的游戏供玩家选择，游戏的种类适合儿童、成人，为游艺厅创造二次盈利的能力，从周末生意变成全天侯的生意"), _c('br'), _c('br'), _vm._v("2.线上游戏中心与线下游戏厅打通，利用积分可以通兑"), _c('br'), _c('br'), _vm._v("3.提供游戏推广运营支持，帮助游艺厅在线上和线下落地，推广游戏事半功倍"), _c('br'), _c('br')])])]), _vm._v(" "), _c('div', {
    staticClass: "bigData"
  }, [_c('img', {
    staticClass: "bigDataPic",
    attrs: {
      "src": require("../assets/bigData.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bigDataContent"
  }, [_c('span', [_vm._v("大数据分析")]), _vm._v(" "), _c('p', [_vm._v("酷酷宝系统有着强大的报表系统。总体营收报表，总投币数、云投币数、实物投币数、购买游戏币数、赠送游戏币数、出彩积分数、兑换游戏币数，以及支持从客户维度、游乐设备维度、门店维度、区域维度进行数据统计和查询，并导出报表。账目清晰，财务人员省心，老板放心")])])]), _vm._v(" "), _c('div', {
    staticClass: "profit"
  }, [_c('img', {
    staticClass: "profitPic",
    attrs: {
      "src": require("../assets/profit.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "profitContent"
  }, [_c('span', [_vm._v("生态盈利")]), _vm._v(" "), _c('p', [_vm._v("生态盈利包含两层意思，首先是，以每个单店为中心的小生态圈，其次是，以好酷好玩大联盟为中心的大生态圈"), _c('br'), _c('br'), _vm._v("在小的生态圈中，咱们每个游乐园，通过经营自己的客户把线下的客户转为线上的粉丝，然后可以对接当地的广告商、手游商、经营自己的积分商城、周边的商家合作等，形成一个区域性的生态链，把粉丝变现"), _c('br'), _c('br'), _vm._v("然而，一个游乐园所积累的粉丝有限，所能够整合的资源有限，所能承载的需求有限，甚至在整合合作中，还是相对弱势的，这时一个大的生态联盟，就很有必要。就会改变我们单打独斗的弱势局面，可以承载全国性的广告诉求，所以我们未来的生态盈利变现，必须依靠千万粉丝为基础，我们才有讨价还价的筹码"), _c('br'), _c('br'), _vm._v("我们全国有四万多家游乐园，每家只有一万粉丝，那么整个盘子也有四亿粉丝，所以大联盟具有更大的商业价值")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-85f014f4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/product.vue
// module id = 281
// module chunks = 1